/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Service / Resource Icons 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "./resourceTypeConstants";
import {faStripe} from "@fortawesome/free-brands-svg-icons";

import {
	faUniversity,
	faBoxUsd,
	faCalendarStar,
	faScrollOld,
	faCommentLines,
	faCreditCardFront,
	faUserLock,
	faSearch,
	faCctv,
	faFileAlt,
	faUsers,
	faBrowser,
	faSolarSystem,
	faPiggyBank,
	faSackDollar,
	faCommentsDollar,
	faEnvelopeOpenDollar,
	faPercentage,
	faMoneyCheckAlt,
	faReceipt,
	faForklift,
	faPortalExit,
	faAbacus,
	faBalanceScaleLeft,
	faUserHeadset,
	faFileContract,
	faBuilding,
	faMapMarkedAlt,
	faRulerVertical,
	faRulerTriangle,
	faDraftingCompass,
	faCoin,
	faAlbumCollection,
	faDrawPolygon,
	faClipboardListCheck,
	faBells,
	faUserCowboy,
	faSlidersV,
	faRobot,
	faBooks,
	faTransporter2,
	faBookUser,
	faShippingTimed,
	faEnvelopeSquare,
	faMailbox,
	faEnvelope,
	faAt,
	faMailBulk,
	faShoppingBasket,
	faMoneyBillWave,
	faFileInvoiceDollar,
	faFileInvoice,
	faUserClock,
	faUsersClass,
	faNetworkWired,
	faEthernet,
	faSwatchbook,
	faLaptop,
	faPaperclip,
	faChartPieAlt,
	faCommentAltLines,
	faTags,
	faLink,
	faGhost,
	faInboxOut,
	faCoins,
	faDolly,
	faCloudHail,
	faUserCheck,
	faCheckDouble,
	faBookDead,
	faLock,
	faScanner,
	faKey,
	faParachuteBox,
	faExchange,
	faScannerKeyboard,
	faUser,
	faWallet,
	faTreasureChest,
	faCogs,
	faNotEqual,
	faFlagUsa,
	faGlobeEurope,
	faCassetteTape,
	faUserAlien,
} from "@fortawesome/pro-solid-svg-icons";

export const SERVICE_ICONS_DICT = {
	banking: faUniversity,
	deposits: faBoxUsd,
	events: faCalendarStar,
	history: faScrollOld,
	messaging: faCommentLines,
	payments: faCreditCardFront,
	permissions: faUserLock,
	search: faSearch,
	security: faCctv,
	storage: faFileAlt,
	user_accounts: faUsers,
	frontend: faBrowser,
	system_general: faSolarSystem,
	yardi: faSolarSystem,
};

export const RESOURCE_ICONS_DICT = {
	[RESOURCE_TYPE_BANK_ACCOUNT]: faPiggyBank,
	[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST]: faSackDollar,
	[RESOURCE_TYPE_BANK_TRANSFER]: faCommentsDollar,
	[RESOURCE_TYPE_BULK_FUNDS_TRANSFER]: faEnvelopeOpenDollar,
	[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE]: faPercentage,
	[RESOURCE_TYPE_DEPOSIT]: faMoneyCheckAlt,
	[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT]: faReceipt,
	[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT]: faReceipt,
	[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT]: faForklift,
	[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST]: faPortalExit,
	[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST]: faPortalExit,
	[RESOURCE_TYPE_DEPOSIT_INTEREST]: faSackDollar,
	[RESOURCE_TYPE_DEPOSIT_INVITE]: faEnvelopeOpenDollar,
	[RESOURCE_TYPE_DEPOSIT_USER_STATS]: faAbacus,
	[RESOURCE_TYPE_DISPUTE]: faBalanceScaleLeft,
	[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST]: faUserHeadset,
	[RESOURCE_TYPE_DISPUTE_SPLIT]: faFileContract,
	[RESOURCE_TYPE_PROPERTY]: faBuilding,
	[RESOURCE_TYPE_PROPERTY_ADDRESS]: faMapMarkedAlt,
	[RESOURCE_TYPE_COMPLIANCE]: faRulerVertical,
	[RESOURCE_TYPE_COMPLIANCE_RULE]: faRulerTriangle,
	[RESOURCE_TYPE_COMPLIANCE_HISTORY]: faRulerTriangle,
	[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING]: faDraftingCompass,
	[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG]: faCoin,
	[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS]: faCoin,
	[RESOURCE_TYPE_PMC_REPORT_TIMETABLE]: faCalendarStar,
	[RESOURCE_TYPE_DEPOSIT_GROUP]: faAlbumCollection,
	[RESOURCE_TYPE_DEPOSIT_USER_GROUP]: faDrawPolygon,
	[RESOURCE_TYPE_PROPERTY_GROUP]: faDrawPolygon,
	[RESOURCE_TYPE_PROPERTY_USER_GROUP]: faDrawPolygon,
	[RESOURCE_TYPE_ACTION_ITEM]: faClipboardListCheck,
	[RESOURCE_TYPE_EVENT]: faCalendarStar,
	[RESOURCE_TYPE_NOTIFICATION]: faBells,
	[RESOURCE_TYPE_EVENT_HOOK]: faBells,
	[RESOURCE_TYPE_ONLINE_USER]: faUserCowboy,
	[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS]: faSlidersV,
	[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY]: faRobot,
	[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY]: faBooks,
	[RESOURCE_TYPE_UPDATE_LOG_ENTRY]: faTransporter2,
	[RESOURCE_TYPE_USER_HISTORY_ENTRY]: faBookUser,
	[RESOURCE_TYPE_SNAPSHOT]: faBookUser,
	[RESOURCE_TYPE_EMAIL_EVENT]: faShippingTimed,
	[RESOURCE_TYPE_EMAIL_TEMPLATE]: faEnvelopeSquare,
	[RESOURCE_TYPE_MAILBOX]: faMailbox,
	[RESOURCE_TYPE_MAILBOX_MESSAGE]: faEnvelope,
	[RESOURCE_TYPE_MAILBOX_META_DATA]: faAt,
	[RESOURCE_TYPE_SENT_EMAIL]: faMailBulk,
	[RESOURCE_TYPE_PAYMENT_REQUEST]: faShoppingBasket,
	[RESOURCE_TYPE_STRIPE_PAYMENT_LOG]: faStripe,
	[RESOURCE_TYPE_USER_WITHDRAW]: faMoneyBillWave,
	[RESOURCE_TYPE_INVOICE]: faFileInvoiceDollar,
	[RESOURCE_TYPE_INVOICE_ITEM]: faFileInvoice,
	[RESOURCE_TYPE_LOAN_APPLICATION]: faFileInvoice,
	[RESOURCE_TYPE_LOAN_SYSTEM_INFO]: faFileInvoice,
	[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT]: faFileInvoice,
	[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT]: faFileInvoice,
	[RESOURCE_TYPE_LOAN]: faCoin,
	[RESOURCE_TYPE_LOAN_HISTORY]: faCoin,
	[RESOURCE_TYPE_LOAN_PAYMENT_LOG]: faCoin,
	[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG]: faCoin,
	[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO]: faCoin,
	[RESOURCE_TYPE_SEZZLE_ORDER]: faCoin,
	[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT]: faCoin,
	[RESOURCE_TYPE_PERMISSION_ENTRY]: faUserLock,
	[RESOURCE_TYPE_PERMISSION_LOG_ENTRY]: faUserClock,
	[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS]: faUsersClass,
	[RESOURCE_TYPE_RESOURCE_PERMISSIONS]: faUsersClass,
	[RESOURCE_TYPE_ORGANIZATION]: faUsersClass,
	[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE]: faUsersClass,
	[RESOURCE_TYPE_IP_ADDRESS]: faNetworkWired,
	[RESOURCE_TYPE_KNOWN_IP_ADDRESS]: faEthernet,
	[RESOURCE_TYPE_KNOWN_USER_AGENT]: faSwatchbook,
	[RESOURCE_TYPE_USER_AGENT]: faLaptop,
	[RESOURCE_TYPE_ATTACHED_STORAGE_FILES]: faPaperclip,
	[RESOURCE_TYPE_STORAGE_FILE]: faFileAlt,
	[RESOURCE_TYPE_SYSTEM_STATS]: faChartPieAlt,
	[RESOURCE_TYPE_RESOURCE_NOTE]: faCommentAltLines,
	[RESOURCE_TYPE_DEPOSIFY_TAG]: faTags,
	[RESOURCE_TYPE_PERMANENT_LINK]: faLink,
	[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST]: faGhost,
	[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE]: faInboxOut,
	[RESOURCE_TYPE_BALANCE_CHANGE_LOG]: faCoins,
	[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER]: faDolly,
	[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG]: faCloudHail,
	[RESOURCE_TYPE_EMAIL_VERIFICATION]: faUserCheck,
	[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD]: faCheckDouble,
	[RESOURCE_TYPE_EXPIRED_PASSWORD]: faBookDead,
	[RESOURCE_TYPE_FUNDS_LOCK]: faLock,
	[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG]: faScanner,
	[RESOURCE_TYPE_PASSWORD]: faKey,
	[RESOURCE_TYPE_PASSWORD_RESET]: faParachuteBox,
	[RESOURCE_TYPE_PENDING_EMAIL_CHANGE]: faExchange,
	[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS]: faAlbumCollection,
	[RESOURCE_TYPE_RELEASED_FUNDS_LOCK]: faScannerKeyboard,
	[RESOURCE_TYPE_USER_ACCOUNT]: faUser,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE]: faWallet,
	[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE]: faTreasureChest,
	[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS]: faCogs,
	[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA]: faNotEqual,
	[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT]: faFlagUsa,
	[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT]: faGlobeEurope,
	[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD]: faCassetteTape,
	[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION]: faUserAlien,
	[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING]: faUserAlien,
	[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_XML]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PET]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_EVENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PHONE]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY]: faDrawPolygon,
	[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS]: faDrawPolygon,
};

export function getServiceIcon(serviceID){
	return SERVICE_ICONS_DICT[serviceID];
}

export function getResourceIcon(resourceType){
	return RESOURCE_ICONS_DICT[resourceType];
}

